import type { UserDesignItem, UserDesignSlideItem } from '@/types';

/**
 * デザイン一覧をスライド用のアイテムに分割する
 * @param designList - デザインアイテムの一覧
 * @param perPage - 1スライドあたりの表示数
 * @returns スライドごとにグループ化されたアイテム配列
 */
export const createSlideItems = (designList: UserDesignItem[], perPage: number): UserDesignSlideItem[] => {
  if (perPage <= 0 || designList.length === 0) {
    return [];
  }

  // 必要なスライド数を算出
  const totalPageCount = Math.ceil(designList.length / perPage);
  const items: UserDesignSlideItem[] = [];

  // perPage件ずつ切り出してスライド単位にグループ化
  for (let pageId = 0; pageId < totalPageCount; pageId++) {
    const startIndex = pageId * perPage;
    const endIndex = startIndex + perPage;
    const pageItems = designList.slice(startIndex, endIndex);
    items.push({
      id: pageItems[0].id,
      items: pageItems,
    });
  }
  return items;
};
